import { Pipe, PipeTransform } from '@angular/core'
import { CustomFieldValue } from '../store/manage-subscription.state'
import { environment } from '@environment/environment'

@Pipe({
  name: 'filterCustomFields',
})
export class FilterCustomFieldsPipe implements PipeTransform {
  private fieldsThatMatter: string[] = [...environment.subscriptionCustomFields, environment.uwg7Id, environment.doiId]

  transform(value: CustomFieldValue[]): CustomFieldValue[] {
    return value.filter(v => this.fieldsThatMatter.includes(v.customFieldId))
  }
}
